module.exports = __webpack_public_path__ + "img/slider_jobmule.e9cea986.png";